import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import CronJobsCRUD from '../CronJobsCRUD';
import { ImportCronJobsContent } from './ImportCronJobsContent';

export const ImportCronJobs = () => {
  const { t } = useTranslation();

  const schema = yup.object().shape({
    config: yup.object().shape({
      importDefinitionId: yup
        .string()
        .nullable()
        .required(t('validation.valueIsRequired'))
    })
  });

  return (
    <CronJobsCRUD schema={schema} defaultFormValues={{ jobName: 'import' }}>
      <ImportCronJobsContent />
    </CronJobsCRUD>
  );
};
